import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.cvp-carousel__carousel', {
    speed: 400,
    spaceBetween: 0,
    slidesPerGroup: 1,
    loop: true,
    modules: [Navigation],
    navigation: {
      prevEl: '.cvp-carousel__prev-button',
      nextEl: '.cvp-carousel__next-button',
    },
    breakpoints: {
      650: {
        spaceBetween: 16,
        slidesPerView: 2,
      },
    },
  });
});
